import { takeEvery } from "@redux-saga/core/effects";
import { ValidationMessagesTypes } from "./../types";
import { changeValidationMessage } from "./changeValidationMessageSaga";

export default function* ValidationsSaga() {
    yield takeEvery(ValidationMessagesTypes.CHANGE_VALIDATION_MESSAGE_REQUEST, changeValidationMessage);
}
